import { IAutopilotContactDetailsFilters } from "../../../reactHooks/filters/contactList/useAutopilotUrlQueryParams";
import CompanyNameFilter from "../../filterOptions/CompanyNameFilter";
import FirstLastNameFilter from "../../filterOptions/FirstLastNameFilter";
import CiroFilterGroup, {
  IFilterSectionProps,
} from "../../shared/CiroFilter/CiroFilterGroup";
import HasEmailFilter from "../../filterOptions/HasEmailFilter";
import HasPhoneNumberFilter from "../../filterOptions/HasPhoneNumberFilter";
import ScoringCriteriaFilter from "../../filterOptions/ScoringCriteriaFilter";
import CiroCheckbox from "../../shared/CiroCheckbox";
import classNames from "classnames";

const CiroFilterSectionContactListFilters = ({
  filters,
  scoringCriteria,
  isCiroEnterprise,
}: {
  filters: IAutopilotContactDetailsFilters;
  scoringCriteria?: { id: number; label: string }[];
  isCiroEnterprise?: boolean;
}) => {
  const {
    firstNameFilter,
    lastNameFilter,
    companyNameFilter,
    excludedCompanyNameFilter,
    hasEmailFilter,
    hasPhoneNumberFilter,
    scoringCriteriaFilter,
    unqualifiedFilter,
    setFirstNameFilter,
    setLastNameFilter,
    setCompanyNameFilter,
    setExcludedCompanyNameFilter,
    setHasEmailFilter,
    setHasPhoneNumberFilter,
    setScoringCriteriaFilter,
    setUnqualifiedFilter,
  } = filters;

  const filterSections = [
    {
      title: "General",
      filters: [
        <FirstLastNameFilter
          key={"firstLastName"}
          firstNameFilter={firstNameFilter}
          lastNameFilter={lastNameFilter}
          setFirstNameFilter={setFirstNameFilter}
          setLastNameFilter={setLastNameFilter}
        />,
        <CompanyNameFilter
          key={"companyName"}
          companyNameFilter={companyNameFilter}
          excludedCompanyNameFilter={excludedCompanyNameFilter}
          setCompanyNameFilter={setCompanyNameFilter}
          setExcludedCompanyNameFilter={setExcludedCompanyNameFilter}
        />,
        <HasEmailFilter
          key={"hasEmail"}
          hasEmailFilter={hasEmailFilter}
          setHasEmailFilter={setHasEmailFilter}
        />,
        <HasPhoneNumberFilter
          key={"hasPhoneNumber"}
          hasPhoneNumberFilter={hasPhoneNumberFilter}
          setHasPhoneNumberFilter={setHasPhoneNumberFilter}
        />,
        scoringCriteria && (
          <ScoringCriteriaFilter
            key={"scoringCriteria"}
            scoringCriteria={scoringCriteria}
            scoringCriteriaFilter={scoringCriteriaFilter}
            setScoringCriteriaFilter={setScoringCriteriaFilter}
          />
        ),
        isCiroEnterprise && (
          <div
            className={classNames("px-4", "mb-4", "mt-2", "text-gray-600")}
            key={"unqualified"}
          >
            <CiroCheckbox
              labelClassName={classNames(
                "select-none",
                "cursor-pointer",
                "text-sm",
              )}
              label={"Show unqualified contacts"}
              checked={unqualifiedFilter || false}
              onClick={(e) => setUnqualifiedFilter(e.target.checked)}
            />
          </div>
        ),
      ],
    },
  ].filter(Boolean) as IFilterSectionProps[];

  return <CiroFilterGroup filterSections={filterSections} />;
};

export default CiroFilterSectionContactListFilters;
